export default __webpack_public_path__ + "static/media/wind-mirror-accept.5165bcdd.png";